"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DomChangeType;
(function (DomChangeType) {
    DomChangeType["NONE"] = "NONE";
    DomChangeType["FULL"] = "FULL";
    DomChangeType["REPLACE"] = "REPLACE";
    DomChangeType["INNER"] = "INNER";
    DomChangeType["OUTER"] = "OUTER";
})(DomChangeType = exports.DomChangeType || (exports.DomChangeType = {}));
exports.default = DomChangeType;
//# sourceMappingURL=DomChangeType.js.map